import {connect} from "react-redux";
import {ContactComponent} from "../../pages/components/ContactComponent";
import {postUserFeedbackAction} from "../apicalls/PostUserFeedback";


const mapStateToProps = (state, ownProps) => {
    const { user } = state;
    return {
        user
    }
};

const mapDispatchToProps = dispatch => {
    return {
        postUserFeedback: (userEmail, userFeedback) => {
            dispatch(postUserFeedbackAction(userEmail, userFeedback))
        }
    }
};

export const ContactAdapter = connect(mapStateToProps, mapDispatchToProps)(ContactComponent);